import React from 'react';
import { Redirect } from "react-router-dom";
import { ContentRoute } from "../_metronic/layout";


const PrivateRoute = ({ component: Component, isAuthenticated, accessDeny, context: Context, name, ...rest }) => (
    <ContentRoute
        {...rest}
        render={props =>
            (!accessDeny
                ? <>
                    {name && <div className="titleBar">{name}</div>}
                    <div className="page-content">
                        {
                            Context ? <Context>
                                <Component {...props} />
                            </Context> :
                                <Component {...props} />
                        }
                    </div>
                </>
                : <Redirect
                    to={{
                        pathname: "/accessDeny",
                        state: { from: props.location }
                    }}
                />)}
    />
);

export default PrivateRoute;
